class SuggestedAmountButton {
  static attrName = 'data-tn-amount';

  /**
   * @param {HTMLElement} $el
   */
  constructor($el) {
    this.$el = $el;

    this.id = this.$el.id;
    this.value = parseFloat($el.getAttribute(SuggestedAmountButton.attrName));
    this.isOtherAmountButton = this.value === 0;
  }

  getIsSelected() {
    return this.$el.classList.contains('btn-primary');
  }
}

export default SuggestedAmountButton;



// WEBPACK FOOTER //
// ./src/onePageGiving/SuggestedAmountButton.js